import {
  ReplaceHistoryStackEntryAction,
  createReplaceHistoryStackEntryActionCreator,
} from '../history-stack';
import { ADMIN_PANELS_HISTORY_ACTION_TYPE_PREFIX } from './constants';
import { AdminPanelName } from '../../state';
import { AdminPanelsActionType } from './admin-panels-action-type';

export type ReplaceAdminPanel = ReplaceHistoryStackEntryAction<
  AdminPanelsActionType.Replace
>;

export const replaceAdminPanel = createReplaceHistoryStackEntryActionCreator<
  AdminPanelsActionType.Replace,
  AdminPanelName,
  any
>(ADMIN_PANELS_HISTORY_ACTION_TYPE_PREFIX);
